import Vue from 'vue'
import Router from 'vue-router'


// 法务
const casedata = () => import("@/components/legalaffairs/case_data");
const caseclass = () => import("@/components/legalaffairs/case_class");
const casestep = () => import("@/components/legalaffairs/case_step");

const lawstore = () => import("@/components/legalaffairs/law_store");

// const filemode = () => import("@/components/legalaffairs/file_mode");
// const applyfile = () => import("@/components/legalaffairs/apply_file");
// const applyfilepass = () => import("@/components/legalaffairs/apply_filepass");
// const applythings = () => import("@/components/legalaffairs/apply_things");

Vue.use(Router)

export default[
	{
		name: "caseclass",
		path: "/caseclass",
		component: caseclass,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "案例类型"
		}
	},
	{
		name: "casedata",
		path: "/casedata",
		component: casedata,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "案例"
		}
	},
	{
		name: "casestep",
		path: "/casestep",
		component: casestep,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "案例步骤"
		}
	},
	{
		name: "lawstore",
		path: "/lawstore",
		component: lawstore,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "律师事务所"
		}
	}
]
